'use client'

import { alpha } from '@mui/material/styles'
import { IconButton } from '@mui/material'
import { ArrowBackIosNew as ArrowBackIosNewIcon, ArrowForwardIos as ArrowForwardIosIcon } from '@mui/icons-material'

// Types
import type { GalleryButtonProps } from '@/types/components/atoms/buttons/gallery'

const GalleryButtonAtom = (props: GalleryButtonProps) => {
	// Props
	const { position, onClick } = props

	return (
		<IconButton
			size="large"
			onClick={onClick}
			sx={theme => ({
				position: 'absolute',
				top: '50%',
				...(position === 'left' && { left: 10 }),
				...(position === 'right' && { right: 10 }),
				color: theme.palette.common.white,
				bgcolor: alpha(theme.palette.common.black, 0.5),
				border: `1px solid ${alpha(theme.palette.common.white, 0.2)}`,
				transform: 'translateY(-50%)',
				zIndex: 1
			})}
		>
			{position === 'left' ? <ArrowBackIosNewIcon /> : <ArrowForwardIosIcon />}
		</IconButton>
	)
}

export default GalleryButtonAtom
